module.exports = __webpack_public_path__ + "img/about-applications-bg.c729706a.png";